//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';

export const getIsBazaarvoiceSyndicationOnlyClient = createSelector(
  (state: ICuralateStore) => state.session.client.isShareV2Vendor,
  (state: ICuralateStore) =>
    state.session.features.bazaarvoice_network_syndication,
  (isShareV2Vendor, isBazaarvoiceSyndicationEnabled) => {
    return isShareV2Vendor && isBazaarvoiceSyndicationEnabled;
  },
);
